// extracted by mini-css-extract-plugin
export default {"containerBox":"LanguageSwitcher_containerBox__gJGR8","hidden":"LanguageSwitcher_hidden__cWkpc","mobileLang":"LanguageSwitcher_mobileLang__jy53-"};